import React, { lazy, Suspense } from "react"
import Accordian from "tcp-common/lib/components/Accordian/Accordian"
import { AccordianHeading } from "./styles"
import { Skeleton } from "@mui/material"
const AccordianData = lazy(() => import("./AccordianData"))

const AccordianComponent = (props) => {
    const renderView = () => (
        <Accordian
            makeWholeDivClickable
            HeadingComponent={
                <div style={{ width: "90%", cursor: "pointer" }} role="list">
                    <AccordianHeading>{props.accordianHeader}</AccordianHeading>
                </div>
            }
            accordianWithBorder
            containerInputProps={{
                margin: "0 0 24px 0"
            }}
            headingLabel="Dropdown"
            withSlideTransition>
            <Suspense
                fallback={<Skeleton variant="rectangular" height={100} />}>
                {props.data.map((item, index) => {
                    return <AccordianData item={item} key={index} />
                })}
            </Suspense>
        </Accordian>
    )

    return renderView()
}

export default AccordianComponent
